import { BaseEntityService } from "../BaseEntityService"
import { SubscriptionModel } from "../../data/entities/billing";
import { SubscriptionODataRepo, SubscriptionRepo } from "../../data/repo";

export class SubscriptionService extends BaseEntityService<SubscriptionModel, SubscriptionRepo, SubscriptionODataRepo> {
  constructor(){
    super(new SubscriptionRepo(), new SubscriptionODataRepo());
  }
}

export default SubscriptionService;
